import styled from "@emotion/styled";

export const SwipeHandler = styled.div`
  height: 2rem;
  position: relative;
  left: 0;
  width: 100%;
  top: 0;
  background: transparent;
  cursor: pointer;
  z-index: 10;

  &::after {
    content: "";
    width: 36px;
    height: 6px;
    position: absolute;
    left: 50%;
    top: 50%;
    margin-left: -18px;
    margin-top: -3px;
    border-radius: 3px;
    background: #666;
  }
`;
